import NoAccess from "pages/noAccess/index";
import { ErrorBoundary } from "react-error-boundary";

const ErrorHandler = ({ children }) => {

    return (
        <ErrorBoundary
            fallbackRender={({ error, resetErrorBoundary }) => <NoAccess error message={error} />}
            onReset={(details) => {
                // Reset the state of your app so the error doesn't happen again
            }}
        >
            {children}
        </ErrorBoundary>
    )
}

export default ErrorHandler;

export const ApiErrorHandler = (error) => {
    if (error?.response && error?.response?.data) {
        if (error?.response?.data?.errors && typeof error?.response?.data?.errors === 'object') {
            const errorObj = error?.response?.data.errors;
            let errorMsg = "";
            for (let key in errorObj)
                errorMsg += errorObj[key][0]
            if (errorMsg.includes("is required"))
                errorMsg = errorMsg.replace(/\sis required/ig, ", ").replace(/(\s(The))|(,\s\.?$)/ig, "").replace(/([A-Z])/g, ' $1') + " is required."
            return errorMsg
        } else if (typeof error?.response?.data === 'string') {
            if (error?.response?.data?.includes("Exception:")) {
                const errorMessage = error?.response?.data?.split("Exception:")
                return errorMessage.length !== 1 ? errorMessage[1] !== '' ? errorMessage[1] : errorMessage[0] : error?.response?.data;
            } else {
                return error?.response?.data;
            }
        } else {
            return `${error.response?.data?.title || error?.response?.data?.error || error?.response?.data}`;
        }
    } else if (error?.request) {
        return "No response received from the server. Please try again later.";
    }
    else {
        return `An error occurred while making the request: ${error?.message}`;
    }
}

